import "./Home.css"
import Module from "../../Model/Module"
import BoxesModules from "../../Components/BoxesModule/BoxesModule";
import Report from "../../Components/Report/Report";

import { areCollectionsLoadedAtom, areUploadedDocumentsLoadedAtom, collectionsAtom, uploadedDocumentsAtom } from "../../LoadData/LoadData";
import { userAtom } from "../../RecoilApp";

// import folder_icon from "../../assets/folder_icon.png";
// import clipboard_icon from "../../assets/clipboard_icon.png";
import reception from "../../assets/reception.png";
import envoi from "../../assets/envoi.png";
import mon_compte from "../../assets/mon_compte.png";
import policy_icon from "../../assets/policy.png";
import { useRecoilValue } from "recoil";
import Collection from "../../Model/Collection";
import Loc from "../../../Loc/Loc";

const orange = "#f9b233";
const saumon = "#ee767e";
const bleu = "#3abad9";
const vert = "#95c11e";

interface HomeProps {
    setPageOnClick: (page: string) => void;
}

function define_number_of_docs_from_collections(collecions: Collection[]) {
    let nbr_of_docs: number = 0;

    collecions.forEach(collection => {
        nbr_of_docs += collection.navettes.length;
    })
    return (nbr_of_docs);
}

export default function Home (props : HomeProps) {
    const collections = useRecoilValue(collectionsAtom);
    const user = useRecoilValue(userAtom);
    const areCollectionsLoaded = useRecoilValue(areCollectionsLoadedAtom);
    const uploadedDocuments = useRecoilValue(uploadedDocumentsAtom);
    const areUploadedDocumentsLoaded = useRecoilValue(areUploadedDocumentsLoadedAtom);
    const box1: Module = {NbrOfDocs : define_number_of_docs_from_collections(collections), isLoaded : areCollectionsLoaded || define_number_of_docs_from_collections(collections) !== 0, Name : Loc.trad().HomeReceiveName, Description : Loc.trad().HomeReceiveDesc, Logo : reception, Url : Loc.trad().HomeSee, Background : orange, Page : "RecepDocs"};
    const box2: Module = {NbrOfDocs : uploadedDocuments.length, isLoaded : areUploadedDocumentsLoaded, Name : Loc.trad().HomeSendName, Description : Loc.trad().HomeSendDesc, Logo : envoi, Url : Loc.trad().HomeSee, Background : saumon, Page : "SendDocs"};
    const box3: Module = {NbrOfDocs : -1, isLoaded : true, Name : Loc.trad().HomeAccountName, Description : Loc.trad().HomeAccountDesc, Logo : mon_compte, Url : Loc.trad().HomeSee, Background : bleu, Page : "MyAccount"};
    const box4: Module = {NbrOfDocs : -1, isLoaded : true, Name : Loc.trad().HomePolicyName, Description: Loc.trad().HomePolicyDesc, Logo : policy_icon, Url : Loc.trad().HomeSee, Background: vert, Page : "FivesPolicy"};
    // const box5: Module = {NbrOfDocs : -1, isLoaded : true, Name : "Module par défaut", Description: "description", Logo : reception, Url : "Url", Background: "", Page : "Home"};

    const boxes: Module[] = [box1, box2, box3, box4];

    return (
        <div>
            <div className="Home">
                <BoxesModules boxes={boxes} setPageOnClick={props.setPageOnClick}></BoxesModules>
            </div>
            <Report></Report>
        </div>
    );
}